import React, { memo } from 'react'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import Routes from '../Routes/Routes'
import AxiosAuthBootstrap from '../api/AxiosAuthBootstrap'

const Layout = () => {
  return (
    <>
      <AxiosAuthBootstrap />
      <Routes />
      <ToastContainer />
    </>
  )
}

export default memo(Layout)
